// Import SplideJS
import Splide from "@splidejs/splide";

// Import UIkit
import UIkit from "uikit";

// Import Slick
// Not importing the npm library, because of a bug
// https://github.com/kenwheeler/slick/pull/3307
// import "slick-carousel";

var custom = (function ($, window, document, Drupal, drupalSettings, once) {
  // Add class on click to an element
  function addClassOnclick($element, $class) {
    if ($element.hasClass($class)) {
      $element.removeClass($class);
    } else {
      $element.addClass($class);
    }
  }

  /*
   * Mobile Navigation: open/close the navigation
   */
  Drupal.behaviors.mobileNavigation = {
    attach: function (context) {
      const navigation = $("#flyout-navigation");
      const bodyEl = $("body");
      const htmlEl = $("html");
      const stickerEl = $(".sticker");

      $(once("mobile-navigation", "#nav-btn"), context).click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).toggleClass("open");
        navigation.toggleClass("open");
        bodyEl.toggleClass("fix-body");
        htmlEl.toggleClass("fix-body");
        stickerEl.toggleClass("z-index-1");
      });
    },
  };

  /*
   * Dropdown menu - main nav
   */
  Drupal.behaviors.menuDropdown = {
    attach: function (context) {
      const expandedEl = $(".menu--main li.menu-item--expanded");
      const layoutEl = $("main");
      const footerEl = $("footer");
      const stickerEl = $(".sticker");

      $(once("menu-dropdown", expandedEl), context)
        .mouseover(function () {
          layoutEl.addClass("menu-open");
          footerEl.addClass("menu-open");
          stickerEl.addClass("z-index-1");
        })
        .mouseleave(function () {
          layoutEl.removeClass("menu-open");
          footerEl.removeClass("menu-open");
          stickerEl.removeClass("z-index-1");
        });
    },
  };

  /*
   * Mobile Navigation: collapsible menu elements
   */
  Drupal.behaviors.collapsibleMobileNavigation = {
    attach: function (context) {
      const menuEl = $(
        "#block-lt21-mobile-navigation > .menu > li > span",
        context
      );

      $(once("collapsible-mobile-navigation", "#block-lt21-mobile-navigation > .menu > li > span"), context).click(function (e) {
        let windowsWidth = $(window).outerWidth();

        if (windowsWidth <= 1000) {
          e.preventDefault();
          e.stopPropagation();
          //Open and Close Menu
          menuEl.not(this).next().slideUp();
          menuEl.not(this).removeClass("arrow-open");
          $(this).next().slideToggle("fast");
          $(this).toggleClass("arrow-open");
        }
      });
    },
  };

  /*
   * Header on scroll
   */
  Drupal.behaviors.headerOnScroll = {
    attach: function () {
      // Hide Header on on scroll down
      var didScroll;
      var lastScrollTop = 0;
      var delta = 5;
      var navbarHeight = $(".header").outerHeight();

      $(window).scroll(function () {
        didScroll = true;
      });

      setInterval(function () {
        if (didScroll) {
          const param = $(this);
          hasScrolled(param);
          didScroll = false;
        }
      }, 200);

      function hasScrolled(obj) {
        var st = obj.scrollTop();

        // Make sure they scroll more than delta
        if (Math.abs(lastScrollTop - st) <= delta) return;

        // If they scrolled down and are past the navbar, add class .nav-up.
        // This is necessary so you never see what is "behind" the navbar.
        if (st > lastScrollTop && st > navbarHeight) {
          // Scroll Down
          $(".header, body").removeClass("nav-down").addClass("nav-up");
        } else {
          // Scroll Up
          if (st + $(window).height() < $(document).height()) {
            $(".header, body").removeClass("nav-up").addClass("nav-down");
          }
        }

        lastScrollTop = st;
      }
    },
  };

  /*
   * Paragraph collapsible
   */
  Drupal.behaviors.paragraphCollapsible = {
    attach: function (context) {
      const paragraphEl = $(".paragraph-collapsible");

      $(paragraphEl, context).each(function () {
        let paragraph = $(this);
        let content = paragraph.find(".paragraph-collapsible__content");

        $(once("paragraph-collapsible", paragraph.find(".paragraph-collapsible__header"))).click(function () {
          if (paragraph.hasClass("paragraph-collapsible--open")) {
            content.slideToggle("fast", function () {
              paragraph
                .addClass("paragraph-collapsible--close")
                .removeClass("paragraph-collapsible--open");
            });
          } else {
            content.slideToggle("fast", function () {
              var currentSlide = paragraph
                .find(".slick-slider")
                .slick("slickCurrentSlide");
              paragraph
                .find(".slick-slider")
                .slick("slickGoTo", currentSlide, true);
              paragraph.find(".slick-slider").slick("refresh");
              paragraph
                .addClass("paragraph-collapsible--open")
                .removeClass("paragraph-collapsible--close");
            });
          }
        });
      });
    },
  };

  /*
   * Paragraph promo slider
   */
  Drupal.behaviors.promoSlider = {
    attach: function (context) {
      let splideId = $("#splide");

      if (splideId.length > 0) {
        let splide = new Splide("#splide", {
          pagination: false,
          perPage: 1,
          autoplay: true,
        });

        // Slide init
        splide.mount();
        
        // Event handler for when slide becomes active
        splide.on('active', function(slide) {
          // Get the custom interval from data attribute if available
          const interval = slide.slide.dataset.splideInterval;
          if (interval) {
            // Reset the autoplay with custom interval
            const autoplay = splide.Components.Autoplay;
            autoplay.pause();
            setTimeout(function() {
              autoplay.play();
            }, parseInt(interval));
          }
        });

        // Check window size
        $(window).on("load resize", function () {
          let windowSize = $(this).width();
          let slideDesktop = $(".splide__slide.is-desktop");
          let slideMobile = $(".splide__slide.is-mobile");

          if (windowSize > 959) {
            slideMobile.detach();
            splide.refresh();
          } else if (windowSize <= 959) {
            slideDesktop.detach();
            splide.refresh();
          }
        });
      }
    },
  };

  /*
   * Person production filter
   */
  Drupal.behaviors.personProductionFilter = {
    attach: function (context) {
      $(
        once(
          "person-production-filter",
          ".spielplan-production-filter",
          context
        )
      ).each(function () {
        const filter = $(this);
        const spielplan = filter.closest("#spielplan");
        const buttons = filter.find(".spielplan-production-filter__chip");
        const items = spielplan.find(".spielplan-item[data-production-id]");
        const status = filter.find(".spielplan-production-filter__status");

        buttons.on("click", function () {
          const button = $(this);
          const isActive = !button.hasClass("is-active");

          button
            .toggleClass("is-active", isActive)
            .attr("aria-pressed", String(isActive));

          const selectedProductionIds = buttons
            .filter(".is-active")
            .map(function () {
              return String($(this).data("production-id"));
            })
            .get();

          items.each(function () {
            const item = $(this);
            const isHidden =
              selectedProductionIds.length > 0 &&
              !selectedProductionIds.includes(
                String(item.data("production-id"))
              );
            item.prop("hidden", isHidden);
          });

          spielplan.find(".season-block-wrapper").each(function () {
            const seasonBlock = $(this);
            seasonBlock.prop(
              "hidden",
              seasonBlock.find(".spielplan-item:not([hidden])").length === 0
            );
          });

          const visibleCount = items.filter(":not([hidden])").length;
          status.text(
            Drupal.formatPlural(
              visibleCount,
              "1 Spieldatum angezeigt.",
              "@count Spieldaten angezeigt."
            )
          );
        });
      });
    },
  };

  /*
   * Paragraph gallery
   */
  Drupal.behaviors.gallerySlider = {
    attach: function (context) {
      $(".paragraph-pg-gallery, .paragraph-journal-gallery", context).each(
        function () {
         $(once("gallery-slider", $(this).find(".slick-slider"))).slick({
            centerMode: true,
            centerPadding: "0",
            slidesToShow: 1,
            initialSlide: 0,
            variableWidth: true,
            infinite: true,
            focusOnSelect: false,
            nextArrow:
              '<div class="slick-next"><div class="arrow-next"></div></div>',
            prevArrow:
              '<div class="slick-prev"><div class="arrow-prev"></div></div>',
          });
        }
      );
    },
  };

  /*
   * Paragraph Cast
   */
  Drupal.behaviors.castSlider = {
    attach: function (context) {
      $(
        ".paragraph-production-manually-cast-crew, .paragraph-production-cast-crew, .paragraph-production-multi-cast-crew",
        context
      ).each(function () {
        $(once("cast-slider", $(this).find(".slick-slider")))
          .slick({
            infinite: false,
            slidesToShow: 4,
            accessibility: true,
            variableWidth: false,
            focusOnSelect: false,
            nextArrow:
              '<div class="slick-next"><div class="arrow-next"></div></div>',
            prevArrow:
              '<div class="slick-prev"><div class="arrow-prev"></div></div>',
            responsive: [
              {
                breakpoint: 900,
                settings: {
                  slidesToShow: 2,
                },
              },
              {
                breakpoint: 450,
                settings: {
                  slidesToShow: 1,
                },
              },
            ],
          });
      });
    },
  };

  /*
   * Journal Slider with SplideJS
   */
  Drupal.behaviors.journalSlider = {
    attach: function () {
      Drupal.globalJournalSlider();
    },
  };

  Drupal.globalJournalSlider = () => {
    const elms = document.getElementsByClassName("splide--journal");

    for (let i = 0; i < elms.length; i++) {
      new Splide(elms[i], {
        pagination: false,
        perPage: 1,
      }).mount();
    }
  };

  /*
   * Journal Slider: Teaser Small with SplideJS
   */
  Drupal.behaviors.journalSliderTeaser = {
    attach: function () {
      Drupal.globalJournalSliderTeaser();
    },
  };

  Drupal.globalJournalSliderTeaser = () => {
    const elms = document.getElementsByClassName("splide--journal-small");

    for (let i = 0; i < elms.length; i++) {
      new Splide(elms[i], {
        pagination: false,
        perPage: 4,
        perMove: 1,
        gap: "40px",
        breakpoints: {
          1200: {
            perPage: 3,
          },
          850: {
            perPage: 2,
          },
          550: {
            perPage: 1,
          },
        },
      }).mount();
    }
  };

  /*
   * CT Person: Switch the language of the biography
   */
  Drupal.behaviors.switchBioLanguage = {
    attach: function () {
      const langDE = $(".node-person-full__bio--de");
      const langEN = $(".node-person-full__bio--en");
      const btnDE = $(".language-toggle--de");
      const btnEN = $(".language-toggle--en");

      // German switcher
      $(once("switch-bio-language", ".language-toggle--de")).click(function () {
        $(this).addClass("is-active");
        langDE.addClass("is-active");
        btnEN.removeClass("is-active");
        langEN.removeClass("is-active");
      });

      // English switcher
      $(once("switch-bio-language", ".language-toggle--en")).click(function () {
        $(this).addClass("is-active");
        langEN.addClass("is-active");
        btnDE.removeClass("is-active");
        langDE.removeClass("is-active");
      });
    },
  };

  /*
   * Webform: Floating label
   */
  Drupal.behaviors.inputFloatingLabel = {
    attach: function (context) {
      var formFields = $(".form-item", context);

      formFields.each(function () {
        var field = $(this);
        var input = field.find(
          ".form-email, .form-text, .form-tel, .form-number, .form-textarea"
        );
        var label = field.find("label");

        // Check if input is fill
        input.filter(function () {
          if (input.val().length > 0) {
            label.addClass("float-label");
          } else {
            label.removeClass("float-label");
          }
        });

        // Add floating label on focus in
        input.focusin(function () {
          label.addClass("float-label");
        });

        // Delete floating label on focus in
        input.focusout(function () {
          if (!input.val()) {
            label.removeClass("float-label");
          } else {
            label.addClass("float-label");
          }
        });
      });
    },
  };

  /*
   * Smooth scroll effect
   */
  Drupal.behaviors.smoothScroll = {
    attach: function () {
      // Select all links with hashes
      $(once("smooth-scroll", $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').not(".calendar-day")))
        .click(function (event) {
          // On-page links
          if (
            location.pathname.replace(/^\//, "") ==
              this.pathname.replace(/^\//, "") &&
            location.hostname == this.hostname
          ) {
            // Figure out element to scroll to
            let target = $(this.hash);
            target = target.length
              ? target
              : $("[name=" + this.hash.slice(1) + "]");

            // Does a scroll target exist?
            if (target.length) {
              // Only prevent default if animation is actually gonna happen
              event.preventDefault();
              $("html, body").animate(
                {
                  scrollTop: target.offset().top,
                },
                800
              );
            }

            if (
              target.length &&
              target.hasClass("paragraph-collapsible--close")
            ) {
              event.preventDefault();
              target
                .find(".paragraph-collapsible__content")
                .slideToggle("fast", function () {
                  target
                    .addClass("paragraph-collapsible--open")
                    .removeClass("paragraph-collapsible--close");
                });
            }
          }
        });
    },
  };

  /*
   * Clap button
   */
  Drupal.behaviors.clapButton = {
    attach: function (context) {
      const header = $(".node-journal-full__clap-wrapper", context);

      $(window).scroll(function () {
        if ($(this).scrollTop() > 1) {
          header.addClass("is-visible");
        } else {
          header.removeClass("is-visible");
        }
      });
    },
  };

  /*
   * Expand element by anchor
   */
  Drupal.behaviors.expandElementByAnchor = {
    attach: function () {
      // Expand element by anchor on load
      //
      $(window).ready(function () {
        const anchor = window.location.hash;
        let target = $(anchor);

        // Does a scroll target exist?
        if (target.length && target.hasClass("paragraph-collapsible--close")) {
          // Only prevent default if animation is actually gonna happen
          target
            .find(".paragraph-collapsible__content")
            .slideToggle("fast", function () {
              target
                .addClass("paragraph-collapsible--open")
                .removeClass("paragraph-collapsible--close");
            });
        }
      });
    },
  };

  // Define a function that will be used both in the Drupal behavior and directly
  function processPopupScrollingText() {
    // Get all popup banners directly from the document
    const popupBanners = document.querySelectorAll(".popup__banner");
    
    popupBanners.forEach(function(popupBanner) {
      // Skip if already processed
      if (popupBanner.getAttribute("data-processed-by-js") === "true") {
        return;
      }
      
      const popupTextContainer = popupBanner.querySelector(".popup__text-container");
      if (!popupTextContainer) return;
      
      // Check if already has multiple text elements
      const textElements = popupTextContainer.querySelectorAll(".popup__text");
      if (textElements.length > 1) return;
      
      const popupText = popupTextContainer.querySelector(".popup__text");
      const popupIcon = popupTextContainer.querySelector(".popup__icon");
      const popupLink = popupTextContainer.querySelector(".popup__link");
      
      if (!popupText) return;
      
      // Fixed number for consistency
      const numDuplicates = 75;
      
      // Clone elements
      for (let i = 0; i < numDuplicates; i++) {
        if (popupText) {
          const newText = popupText.cloneNode(true);
          popupTextContainer.appendChild(newText);
        }
        
        if (popupIcon) {
          const newIcon = popupIcon.cloneNode(true);
          popupTextContainer.appendChild(newIcon);
        }
        
        if (popupLink) {
          const newLink = popupLink.cloneNode(true);
          popupTextContainer.appendChild(newLink);
        }
      }
      
      // Mark as processed
      popupBanner.setAttribute("data-processed-by-js", "true");
    });
  }

  // Use both Drupal behaviors and direct DOM loading to ensure it runs for all users
  Drupal.behaviors.popupScrollingText = {
    attach: function (context, settings) {
      // Ensure this runs when Drupal attaches behaviors
      processPopupScrollingText();
      
      // Also run after a small delay to catch any late-rendered elements
      setTimeout(processPopupScrollingText, 500);
    },
  };
  
  // Also add a window load event to catch all scenarios
  window.addEventListener("load", function() {
    processPopupScrollingText();
    // Run again after a delay to catch any late-rendered elements
    setTimeout(processPopupScrollingText, 1000);
  });

  Drupal.behaviors.openCast = {
    attach: function (context, settings) {
      $(once("date-detail-activator", ".date-detail-activator"))
        .on("click", function () {
          $(this).attr("aria-expanded", function (i, attr) {
            return attr === "true" ? "false" : "true";
          });

          addClassOnclick($(this), "on");
          addClassOnclick($(this).parent().next(".date-detail"), "on");

          // toggle visibility of comma
          $(this).next(".person-separation-comma").toggleClass("hidden");
        });
    },
  };

  Drupal.behaviors.miniCalendarAnchorLinks = {
    attach: function (context, settings) {
      const miniCalendarAnchorLinks = once(
        "miniCalendarAnchorLinks",
        "#spielplan-mini-calendar .calendar-day",
        context
      );

      if (miniCalendarAnchorLinks.length > 0) {
        miniCalendarAnchorLinks.forEach((miniCalendarAnchorLink) => {
          miniCalendarAnchorLink.addEventListener("click", (event) => {
            const headerHeight = $(".header").height();
            // get height of the sticky calendar filters
            const calenadarFilterForm = $(".spielplan-calendar-filter-form");

            let target = $(miniCalendarAnchorLink.hash);

            target = target.length
              ? target
              : $("[name=" + this.hash.slice(1) + "]");

            // Check if you have to scroll up or down
            if (target.offset().top > $(window).scrollTop()) {
              $("html, body").animate(
                {
                  scrollTop:
                    target.offset().top -
                    (calenadarFilterForm ? calenadarFilterForm.height() : 0),
                },
                800
              );
            } else {
              $("html, body").animate(
                {
                  scrollTop:
                    target.offset().top -
                    ((calenadarFilterForm ? calenadarFilterForm.height() : 0) +
                      headerHeight),
                },
                800
              );
            }
          });
        });
      }
    },
  };

  Drupal.behaviors.subscriptionGroupHover = {
    attach: function (context, settings) {
      // Select all elements with the class 'subscription-group-teaser__link'
      const subscriptionGroupTeaser = context.querySelectorAll(
        ".subscription-group-teaser"
      );

      subscriptionGroupTeaser.forEach((teaser) => {
        // Get the closest parent element with the class 'subscription-group-teaser'
        const link = teaser.querySelector(".subscription-group-teaser__link");

        if (teaser) {
          // Add event listener for mouse enter
          link.addEventListener("mouseenter", () => {
            teaser.classList.add("hovered");
          });

          // Add event listener for mouse leave
          link.addEventListener("mouseleave", () => {
            teaser.classList.remove("hovered");
          });
        }
      });
    },
  };
})(jQuery, window, document, Drupal, drupalSettings, once);

export default custom;
